"use client";

import { useEffect } from "react";

import CloseModalIcon from "@/app/shared-components/icons/CloseModalIcon";

export default function BotbPassCancelledModal({
  ticketCount,
  competitionCount,
  onClose,
}: {
  ticketCount: number;
  competitionCount: number;
  onClose: () => void;
}) {
  useEffect(() => {
    document.querySelector("body")?.classList.add("overflow-hidden");
    return () => {
      document.querySelector("body")?.classList.remove("overflow-hidden");
    };
  }, []);

  const handleBrowseCompetitions = () => {
    onClose();
    window.dispatchEvent(
      new CustomEvent("scroll-to-category", {
        detail: "featured",
      })
    );
  };

  return (
    <div>
      <div aria-hidden="true" className="fixed inset-0 z-[9999] bg-black/80" />
      <div className="fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto">
        <div className="flex items-center justify-center w-full min-h-full m-auto p-4">
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="botb-pass-cancelled-title"
            className="relative flex flex-col items-center w-full max-w-[480px] bg-white rounded-xl px-4 pt-8 pb-6 lg:px-7 lg:pt-10 lg:pb-8">
            <button type="button" onClick={onClose} aria-label="Close" className="absolute right-3 top-3 text-gray-5">
              <CloseModalIcon className="size-6" />
            </button>

            <div className="flex flex-col gap-2 lg:gap-2.5 items-center w-full mb-4 lg:mb-6">
              <div
                id="botb-pass-cancelled-title"
                className="font-jost text-[20px] lg:text-[28px] font-semibold leading-[26px] lg:leading-8 text-dark-1 text-center normal-case !mb-0">
                BOTB Pass cancelled
              </div>
              <div className="font-jost text-sm lg:text-lg font-normal leading-5 lg:leading-6 text-gray-1 text-center tracking-[0]">
                Your {ticketCount} BOTB Pass tickets across {competitionCount} competitions will be voided
              </div>
            </div>

            <div className="flex items-center justify-center w-full border border-black/8 rounded-lg bg-gradient-to-b from-[#f8f1fc] to-[#fefdfe] px-3 py-3 mb-6 lg:mb-8">
              <div className="font-jost text-sm lg:text-lg font-normal leading-5 lg:leading-6 text-[#28282B] lg:text-gray-1 text-center tracking-[0] max-w-[289px]">
                You can rejoin BOTB Pass at any time and enter future competitions.
              </div>
            </div>

            <button
              type="button"
              onClick={handleBrowseCompetitions}
              className="theme-btn theme-btn-primary theme-btn-md lg:theme-btn-lg lg:min-h-[52px] w-full max-w-[372px] uppercase">
              Browse all competitions
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
